// extracted by mini-css-extract-plugin
export var wordContainer = "_op-0";